/* InputDate.tsx
   Version: 1.0.1
   Date: 2021-05-28
*/

// eslint-disable-next-line
import * as React from 'react';
import PropTypes from 'prop-types';

export interface InputDateProps {
    className?: string
    name: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputDate: React.FC<InputDateProps> = (props): JSX.Element => {

    InputDate.propTypes = {
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired
    }


    return (
        <input 
            className={props.className ?? 'basic-inputdate'} type='date' 
            data-name={props.name} 
            value={props.value} 
            onChange={props.onChange} 
        />
    );

}

export default InputDate;
